import videosData from '../jsons/videosData.json';

const sortedVideosData = videosData.sort((a, b) => {
  const dateA = new Date(a.date);
  const dateB = new Date(b.date);
  return dateB - dateA;
});

export default sortedVideosData;
